import React from 'react';
import DiscountBadge from './discountBadge';

interface ItemQuantityProps {
    name: string;
}

const ItemQuantity = (
    {
        name,
    }: ItemQuantityProps
) => {
    return (
        <DiscountBadge>
            {name}
        </DiscountBadge>
    );
};

export default ItemQuantity;
